import { render, staticRenderFns } from "./chaperonage.vue?vue&type=template&id=56482bca&scoped=true&"
import script from "./chaperonage.vue?vue&type=script&lang=js&"
export * from "./chaperonage.vue?vue&type=script&lang=js&"
import style0 from "./chaperonage.vue?vue&type=style&index=0&id=56482bca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56482bca",
  null
  
)

export default component.exports